/**
 * Import all module depenencies here.
 * Add commonly used modules to externals.
 */
import core from '../../../app.core.module.js';
import twofaSceConfig from './2fa.sce.config.js';
import twofaSceRoute from './2fa.sce.route.js';
import twofaSceController from './2fa.sce.controller.js';

/**
 * This is the 2fa module. It it the entry point for this website.
 * Only declare the module's dependencies in this file.
 * @namespace 2fa Module
 */
angular.module('twofactorSce', [
  // Shared modules.
  core
])
// Register config.
.config(twofaSceConfig)
// Register route.
.config(twofaSceRoute)
// Register controller.
.controller('twofaSceController', twofaSceController);



export default 'twofactorSce';


// WEBPACK FOOTER //
// ./src/login/2fa/sce/2fa.sce.module.js